import React from 'react';
import './style.css';

export default class Alert extends React.Component {
  render() {
    // Garante que messages seja um array
    const messages = Array.isArray(this.props.messages)
      ? this.props.messages
      : [this.props.messages];

    return (
      <div
        className={`alert${this.props.tipo !== undefined ? ' ' + this.props.tipo : ''}`}
      >
        {messages.map((value, index) => (
          <div
            key={index}
            dangerouslySetInnerHTML={{
              __html: messages.length > 1 ? `• ${value}` : value,
            }}
          />
        ))}
      </div>
    );
  }
}
